/*=========================================================================================
  File Name: moduleCalendarMutations.js
  Description: Calendar Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default {
  ADD_ITEM(state, item) {

    state.users.unshift(item)
  },
  SET_USERS(state, users) {
    try {
      state.users = users.Data;
      //state.users = parsedData;
    } catch (error) {
      console.error("Failed to parse users data JSON:", error);
      state.users = [];
    }
  },
  SET_ROLES(state, roles) {

    try {
      
      //const parsedData = JSON.parse(roles.data);
      state.roles = roles.Data;
    } catch (error) {
      console.error("Failed to parse roles data JSON:", error);
      state.roles = [];
    }
    //state.roles = roles
  },

UPDATE_USER(state, product) {
    const productIndex = state.users.findIndex((p) => p.Id == product.Id)
    if (productIndex !== -1) {
        state.users[productIndex] = { ...state.users[productIndex], ...product };
    }
},
  REMOVE_ITEM(state, itemId) {
      const ItemIndex = state.users.findIndex((p) => p.Id == itemId)
      state.users.splice(ItemIndex, 1)
  },
}
